import React from 'react';
import { Users, Wrench, MapPin } from 'lucide-react';

const TechniciansList = ({ technicians, serviceRequests, searchTerm, getAvailabilityColor, getStatusColor }) => (
  <div className="bg-white rounded-lg shadow-sm border">
    <div className="px-6 py-4 border-b border-gray-200">
      <h2 className="text-xl font-semibold text-gray-900">Technician Assignments</h2>
    </div>
    <div className="divide-y divide-gray-200">
      {technicians.length === 0 ? (
        <div className="p-8 text-center">
          <Users className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">No Technicians Found</h3>
          <p className="text-gray-600 mb-4">
            No registered technicians are available in the system.
          </p>
          <p className="text-sm text-gray-500">
            To add technicians, register users with the "Technician" role in the user management section.
          </p>
        </div>
      ) : (
        technicians.filter(tech => {
          // Add safety checks to prevent JavaScript errors
          if (!tech || typeof tech !== 'object') return false;

          const name = tech.name || '';
          const specialization = tech.specialization || '';
          const search = searchTerm || '';

          return name.toLowerCase().includes(search.toLowerCase()) ||
                 specialization.toLowerCase().includes(search.toLowerCase());
        }).map((technician) => {
          const assignments = serviceRequests.filter(req => req.assignedTo === technician.name);
          return (
            <div key={technician.id} className="p-6 hover:bg-gray-50">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-lg font-medium text-gray-900">{technician.name}</h3>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getAvailabilityColor(technician.availability)}`}>
                      {technician.availability}
                    </span>
                  </div>

                  <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                    <div className="flex items-center gap-1">
                      <Wrench className="h-4 w-4" />
                      {technician.specialization}
                    </div>
                    <div className="flex items-center gap-1">
                      <MapPin className="h-4 w-4" />
                      {technician.serviceArea}
                    </div>
                    <div>
                      {technician.experience} years exp
                    </div>
                    <div>
                      {technician.rating}★ rating
                    </div>
                  </div>

                  <div className="mt-3">
                    <h4 className="text-sm font-medium text-gray-900 mb-2">Current Assignments ({assignments.length})</h4>
                    {assignments.length > 0 ? (
                      <div className="space-y-2">
                        {assignments.map((assignment) => (
                          <div key={assignment.id} className="bg-gray-50 p-3 rounded-lg">
                            <div className="flex items-center justify-between">
                              <div>
                                <div className="font-medium text-sm">{assignment.title}</div>
                                <div className="text-xs text-gray-600">{assignment.property} • Due: {assignment.dueDate}</div>
                              </div>
                              <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(assignment.status)}`}>
                                {assignment.status}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-sm text-gray-500">No current assignments</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  </div>
);

export default TechniciansList;
